import { NgModule } from '@angular/core';
import { OrbBackgroundComponent } from './orb-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        OrbBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        OrbBackgroundComponent
    ]
})
export class NcOrbBackgroundModule { }